module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff?026b7ac9c43c7e04250f00acd510fa49";